export default __webpack_public_path__ + "static/media/ic-home-logout.9ecb6f1b.svg";